import './drawer.scss';

import { useDispatch, useSelector } from 'react-redux';
import { Drawer } from '@mui/material';
import classNames from 'classnames';

import Icon from 'atoms/icon';
import useWindowDimensions from 'hooks/useWindowDimensions';
import AppointmentDrawer from 'organisms/DrawerContent/Appointment';
import ReassignDrawer from 'organisms/DrawerContent/Appointment/Reassign';
import RescheduleDrawer from 'organisms/DrawerContent/Appointment/Reschedule';
import AvailabilityDrawer from 'organisms/DrawerContent/Availability';
import GroomerDrawer from 'organisms/DrawerContent/Groomer';
import NavbarContent from 'organisms/DrawerContent/NavbarContent';
import NewAppointmentDrawer from 'organisms/DrawerContent/NewAppointment';
import PaymentDrawer from 'organisms/DrawerContent/Payment';
import SettingsDrawer from 'organisms/DrawerContent/Settings';
import UnavailableDrawer from 'organisms/DrawerContent/Unavailable';
import { finishEditingSingleAvailability } from 'store/reducers/singleAvailability';
import { finishEditingUnavailability } from 'store/reducers/singleUnavailability';
import { closeDrawer } from 'store/reducers/ui';

export default function DrawerComponent() {
  const dispatch = useDispatch();
  const { isOpen, type, position } = useSelector((state) => state.ui.drawer);
  const { width } = useWindowDimensions();
  const isMobile = width < 600;

  const COMPONENT_TYPES = {
    appointment: AppointmentDrawer,
    availability: AvailabilityDrawer,
    'groomer-edit': GroomerDrawer,
    'groomer-create': GroomerDrawer,
    navbar: NavbarContent,
    'new-appointment': NewAppointmentDrawer,
    payment: PaymentDrawer,
    settings: SettingsDrawer,
    reschedule: RescheduleDrawer,
    reassign: ReassignDrawer,
    unavailable: UnavailableDrawer,
  };

  const getClassName = () => {
    if (type === 'navbar') return 'drawer-navbar';
    return '';
  };

  const onCloseDrawer = () => {
    dispatch(finishEditingSingleAvailability());
    dispatch(finishEditingUnavailability());
    dispatch(closeDrawer());
  };

  const Element = COMPONENT_TYPES[type];

  return (
    <Drawer
      className={classNames(getClassName())}
      anchor={position || 'right'}
      open={isOpen}
      onClose={onCloseDrawer}
    >
      {isMobile && (
        <Icon
          name="close"
          onClick={() => dispatch(closeDrawer())}
          style={{ fill: 'black' }}
          className="mb-20 close-drawer-icon"
        />
      )}
      {Element ? <Element /> : null}
    </Drawer>
  );
}
